import React from 'react';
import styles from './FlatChessViewRequestTabs.module.scss';
import Tabs from '../../common/Tabs/Tabs';
import Tab from '../../common/Tab/Tab';
import { requestInFlatPeriodIndicators } from '../../../constants/reqestForFlat';
import { useDispatch, useSelector } from 'react-redux';
import { setValuesRequestAttributes } from '../../../store/actions/housingStockActions';
import IndicatorBadge from '../../common/IndicatorBadge/IndicatorBadge';

const FlatChessViewRequestTabs = () => {
  const dispatch = useDispatch();

  const valuesRequestAttributes = useSelector(
    (state) => state.housingStockStore.valuesRequestAttributes
  );

  const handleChange = (_evt, newValue) => {
    if (valuesRequestAttributes?.includes(newValue)) {
      const newValues = valuesRequestAttributes?.filter(
        (value) => value !== newValue
      );

      dispatch(setValuesRequestAttributes(newValues));

      return;
    }

    dispatch(
      setValuesRequestAttributes([...valuesRequestAttributes, newValue])
    );
  };

  return (
    <Tabs
      value={valuesRequestAttributes}
      onChange={handleChange}
      className={styles.tabs}
    >
      {requestInFlatPeriodIndicators.map((item, index) => (
        <Tab
          className={styles.tab}
          selectedClassName={styles.tabActive}
          key={item.id || index}
          label={
            <div className={styles.label}>
              <IndicatorBadge bgColor={item.bg} />
              <span>{item.value}</span>
            </div>
          }
          value={item.id}
        />
      ))}
    </Tabs>
  );
};

export default FlatChessViewRequestTabs;
